window.disablePageSubmit = function () {
  $("input[type='submit']").val("Please Wait..")
  $("input[type='submit']").attr("disabled", true)
}

window.enablePageSubmit = function (label) {
  $("input[type='submit']").val(label)
  $("input[type='submit']").attr("disabled", false)
}

window.safeRedirect = function (url) {
  if (!url || typeof url !== "string") {
    return
  }

  try {
    const parsedUrl = new URL(url, window.location.origin)
    const protocol = parsedUrl.protocol.toLowerCase()

    // Only allow same-origin http(s) redirects and block things like javascript: or data:
    if ((protocol !== "http:" && protocol !== "https:") || parsedUrl.origin !== window.location.origin) {
      console.error("Blocked unsafe redirect:", url)
      return
    }

    window.location.href = parsedUrl.href
  } catch (e) {
    console.error("Blocked invalid redirect URL:", url, e)
  }
}

window.find_duplicate_in_array = function (arra1) {
  let isDuplicate = arra1.some(function (item, idx) {
    return arra1.indexOf(item) != idx
  })
  return isDuplicate
}

window.collapseAll = function () {
  $(".collapsible-header").removeClass(function () {
    return "active"
  })
  $(".collapsible").collapsible({ accordion: true })
  $(".collapsible").collapsible({ accordion: false })
}

window.influence_visual_feedback_and_mandatory_correct_for_interactive_page = function ({
  fieldNeutral,
  fieldVisualFeedback,
  fieldMandatoryCorrect,
}) {
  if ($(fieldNeutral).is(":checked")) {
    // Deselect visual_feedback and mandatory_correct

    $(fieldVisualFeedback).prop("checked", false)
    $(fieldMandatoryCorrect).prop("checked", false)

    // Disable visual_feedback and mandatory_correct

    $(fieldVisualFeedback).attr("disabled", true)
    $(fieldMandatoryCorrect).attr("disabled", true)
  } else {
    // Enable visual_feedback and mandatory_correct

    $(fieldVisualFeedback).attr("disabled", false)
    $(fieldMandatoryCorrect).attr("disabled", false)
  }
}

$(document).ready(function () {
  const alt_modal_text_area = $(".alt-modal-text-area")
  $(document).on("click", ".edit-alt-text-modal", function (e) {
    e.preventDefault()
    const input_id = $(this).data("input-id")
    $("#mdl-alt-text-popup").openModal()
    alt_modal_text_area.val($("#" + input_id).val())
    $("#alt-text-len").text(alt_modal_text_area.val().length)
    $("#selected_input_id").val(input_id)
  })

  alt_modal_text_area.keyup(function () {
    $(".alt-save-disabled-button").css("display", "none")
    $(".alt-save-active-button").css("display", "block")
    $(this).val($(this).val().substring(0, 140))
    $("#alt-text-len").text(parseInt($(this).val().length))
  })

  $(".alt-save-button").on("click", function (e) {
    $("#" + $("#selected_input_id").val()).val(alt_modal_text_area.val())
    $(".alt-save-disabled-button").css("display", "block")
    $(".alt-save-active-button").css("display", "none")
    $("#mdl-alt-text-popup").closeModal()
  })

  if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach
  }

  $("#myTags").tagit()
  $("#myPopupTags").tagit()

  $(".stylesheet-field").minicolors()
  $(".select-title-color").minicolors()
  $(function () {
    return $("select.chosen-select").chosen({
      allow_single_deselect: true,
      no_results_text: "No results matched",
      width: "100%",
    })
  })
  $(function () {
    return $("select.chosen-select-open-invite-groups").chosen({
      allow_single_deselect: true,
      no_results_text: "No results matched",
      width: "100%",
      placeholder_text_multiple: "Select Groups",
    })
  })

  $(".course-rating").raty({
    readOnly: true,
    score: function () {
      return $(this).attr("data-score")
    },
    path: "/static/",
  })

  $("#tabs").tabs().addClass("ui-tabs")

  let window_size = $(document).height()
  $(".white-page-height").height(window_size)

  window_size = $(".sde-rightside").height()
  $(".sde-leftside").height(window_size)

  window_size = $(".sde-rightside").height()
  $(".sde-leftside").height(window_size)

  window_size = $(".cp-pop-right-side").height()
  $(".cp-pop-left-side").height(window_size)

  $("#lmain-ip").height($("#rmain-ip").height())

  $(".bp-poster-action-btn").click(function (event) {
    $(this).parents(".blueprint-course").siblings(".bp-poster-actions").toggleClass("leftslide")
    $(this).toggleClass("bp-poster-action-btn-pressed")
  })

  $(".close-actions").click(function (event) {
    $(this).parents(".bp-poster-actions").removeClass("leftslide")
    $(this)
      .parents(".bp-poster-actions")
      .siblings(".blueprint-course")
      .find(".bp-poster-action-btn")
      .toggleClass("bp-poster-action-btn-pressed")
  })

  $(".so-poster-action-btn").click(function (event) {
    $(this).parents(".stories_overview_container").siblings(".so-actions").toggleClass("leftslide")
  })

  $(".close-actions-story").click(function (event) {
    $(this).parents(".so-actions").removeClass("leftslide")
  })

  $(".tp-menuitems ul.collapsible li").click(function (event) {
    $(this).removeClass("active")
  })

  $(".stories_overview #ui-id-2").click(function (event) {
    if (location.href.indexOf("tab-2=true") === -1) {
      window.history.pushState("menuItems", "MenuItems", window.location.href + "?tab-2=true")
    }
    event.preventDefault()
  })

  $("#tabs").tabs().addClass("ui-tabs")
  $(".tabs2").tabs()
  $("#paletteStyles").tabs()
  $("#paletteSecClr").tabs()
  $("#palettefontClr").tabs()
  $("#palettehghlghtClr").tabs()
  $("#palettsTabs").tabs()
  $(".um-pop-tabs").tabs()
  $("#detail-expansion").tabs()
  $("#add-user-tabs").tabs()

  let selected_chapter_id = $("#selected_chapter_id").val()
  if (!!selected_chapter_id) {
    $("#ui-id-" + selected_chapter_id).click()
  }

  $(".collapsible").collapsible()
  CKEDITOR.replaceAll("msg_ckeditor")
  $(".modal-trigger").leanModal({
    ready: function () {
      let visibleModal = $(".modal:visible")
      if (visibleModal.find(".ckeditor-create-tips").length > 0) {
        if (!CKEDITOR.instances["tip_description"]) {
          CKEDITOR.replace("tip_description")
        }
      }
      if ($(".ckeditor-edit-tips").length > 0) {
        $.each(visibleModal.find(".ckeditor-edit-tips"), function (index, edit_tip_elm) {
          if (edit_tip_elm && edit_tip_elm.id && !CKEDITOR.instances[edit_tip_elm.id]) {
            CKEDITOR.replace(edit_tip_elm.id)
          }
        })
      }
      if ($(".ckeditor-menu-items").length > 0) {
        $.each(visibleModal.find(".ckeditor-menu-items"), function (index, edit_menu_elm) {
          if (edit_menu_elm && edit_menu_elm.id && !CKEDITOR.instances[edit_menu_elm.id]) {
            CKEDITOR.replace(edit_menu_elm.id)
          }
        })
      }
    },
  })

  let pallete_size = $(document).height()
  $(".pallete-page").parents(".white-page-height").height(pallete_size)

  let contSize = $(".um-rightside .l-s-filter-cont").height()
  $(".um-leftside .l-s-filter-cont").height(contSize)

  let datepickerContainer = ""

  if (
    window.navigator.userAgent.indexOf("MSIE") !== -1 ||
    window.navigator.userAgent.indexOf("WOW") !== -1 ||
    window.navigator.userAgent.indexOf("Windows NT") !== -1
  ) {
    datepickerContainer = "#date-picker-container"
  }

  $(document).on("click", "#lean-overlay", function (e) {
    $(".mc-calendar.mc-calendar--modal").removeClass("mc-calendar--opened")
  })
  document.querySelectorAll(".inform-datepicker, .datepicker, .datepicker-wave").forEach(function (elem) {
    if (elem.id) {
      let select_date = new Date()
      if (!!elem.value) {
        let converted = moment(elem.value, rails_variables.current_org_date_format).format("MM/DD/YYYY")
        select_date = new Date(converted)
      }
      let datepicker = MCDatepicker.create({
        el: "#" + elem.id,
        dateFormat: rails_variables.current_org_date_format,
        selectedDate: select_date,
        customCancelBTN: "Close",
      })
      datepicker.onSelect(function (date, formatedDate) {
        $(elem).next().val(date)
        elem.value = formatedDate
        elem.dispatchEvent(new Event("change"))
      })
    }
  })

  $("select").material_select()
  $(".dropdown-button").dropdown({ hover: false, alignment: "right" })
  $(".course-settings-dropdown-button").dropdown({ hover: false, alignment: "right", constrainWidth: false })

  $(".dynamic_content_details").on("click", ".dynamic_open_modal", function (e) {
    $($(this).data("modal-id")).openModal()
  })

  if (document.getElementById("uploadBtn") !== null) {
    document.getElementById("uploadBtn").onchange = function () {
      document.getElementById("uploadFile").value = this.value
    }
  }

  if (window.location.href.indexOf("tab-2=true") !== -1) {
    $("#ui-id-2").click()
  }
  if (window.location.href.indexOf("tab-3=true") !== -1) {
    $('a[href="#tabs-3"]').click()
  }

  function handleCheckboxGroup(groupCheckboxes, selectAllCheckbox) {
    groupCheckboxes.change(function () {
      let allChecked = true
      groupCheckboxes.each(function () {
        if (!$(this).prop("checked")) {
          allChecked = false
          return false
        }
      })
      selectAllCheckbox.prop("checked", allChecked)
    })
    groupCheckboxes.trigger("change")
  }
  let allCourseCheckboxes = $('.report-courses input[type="checkbox"]:not(#all_courses)')
  let selectAllCoursesCheckbox = $("#all_courses")
  handleCheckboxGroup(allCourseCheckboxes, selectAllCoursesCheckbox)

  let allPageCheckboxes = $('.report-groups input[type="checkbox"]:not(#all_pages)')
  let selectAllPagesCheckbox = $("#all_pages")
  handleCheckboxGroup(allPageCheckboxes, selectAllPagesCheckbox)

  function setupCharacterCounter(inputField, countElement) {
    const limit = inputField.maxLength < 0 ? "50" : inputField.maxLength
    if (inputField && countElement) {
      const initialLength = inputField.value.length ? inputField.value.length : 0
      inputField.addEventListener("input", function () {
        const currentText = inputField.value
        const currentLength = currentText.length

        if (currentLength >= limit) {
          countElement.classList.add("exceeded")
        } else {
          countElement.classList.remove("exceeded")
        }
        countElement.textContent = currentLength + "/" + limit + " Characters"
      })
      countElement.textContent = initialLength + "/" + limit + " Characters"
    }
  }
  const textFields = document.querySelectorAll(".char_counter_text_field")
  const charCounters = document.querySelectorAll(".char_counter")
  if (textFields && charCounters) {
    textFields.forEach((textField, index) => {
      setupCharacterCounter(textField, charCounters[index])
    })
  }
  $("#all_courses").click(function () {
    if ($(this).get(0).checked) {
      $.each($(".report-courses").find("input[type=checkbox]"), function (index, element) {
        $(element).get(0).checked = true
      })
    } else {
      $.each($(".report-courses").find("input[type=checkbox]"), function (index, element) {
        $(element).get(0).checked = false
      })
    }
  })

  $("#all_pages").click(function () {
    if ($(this).get(0).checked) {
      $.each($(".report-groups").find("input[type=checkbox]"), function (index, element) {
        $(element).get(0).checked = true
      })
    } else {
      $.each($(".report-groups").find("input[type=checkbox]"), function (index, element) {
        $(element).get(0).checked = false
      })
    }
  })

  $("#editor_language").change(function () {
    let l_id = $(this).val()
    let url = window.location.pathname
    let params = new URL(window.location.href).searchParams
    params.delete("selected")
    params.append("selected", l_id)
    if (window.location.href.indexOf("tab-2=true") !== -1 && $("#ui-id-2").parent().hasClass("ui-tabs-active")) {
      params.append("tab-2", "true")
    }
    url += "?" + params
    window.location.href = url
  })

  $("#editor_language").on("chosen:ready", function () {
    $("#editor_language_chosen .chosen-single span").text("")
    $("#editor_language_chosen .chosen-single span").attr("class", $("#selected-flag").attr("data-flag"))
  })

  $(document).on("click", ".display_next_previous_btn", function () {
    let item = $(this).data("item")
    $(this).parents(".display_next_previous_div").removeClass("display_div")
    $(this).parents(".display_next_previous_div").addClass("hide_div")
    $("#" + item).removeClass("hide_div")
    $("#" + item).addClass("display_div")
  })
})
